// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2REln","header":"PatientQuestionnaire_header__1oKNH","info":"PatientQuestionnaire_info__2tKVz"};